import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

export interface AttachmentRef {
  id: string;
  fileName: string;
  fileType?: string;
}

@Component({
  selector: 'app-admin-attachment-viewer',
  templateUrl: './attachment-viewer.component.html',
  styleUrls: ['./attachment-viewer.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminAttachmentViewerComponent {
  @Input() attachments: AttachmentRef[] = [];
  @Input() label = 'Archivos adjuntos';
  @Input() emptyText = 'Sin archivos';
  @Input() compact = false;

  @Output() openAttachment = new EventEmitter<AttachmentRef>();

  loadingId: string | null = null;

  iconFor(fileType: string | undefined, fileName: string): string {
    const t = (fileType || '').toLowerCase();
    const ext = (fileName.split('.').pop() || '').toLowerCase();
    if (t.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif'].includes(ext)) return 'image';
    if (t.startsWith('video/') || ['mp4', 'mov', 'avi', 'wmv'].includes(ext)) return 'movie';
    if (t.startsWith('audio/') || ['mp3', 'wav'].includes(ext)) return 'audiotrack';
    if (t === 'application/pdf' || ext === 'pdf') return 'picture_as_pdf';
    if (['doc', 'docx'].includes(ext)) return 'description';
    if (['xls', 'xlsx'].includes(ext)) return 'table_chart';
    if (['ppt', 'pptx'].includes(ext)) return 'slideshow';
    return 'attach_file';
  }

  colorFor(fileType: string | undefined, fileName: string): string {
    const icon = this.iconFor(fileType, fileName);
    switch (icon) {
      case 'image': return '#16a34a';
      case 'movie': return '#7c3aed';
      case 'audiotrack': return '#ea580c';
      case 'picture_as_pdf': return '#dc2626';
      case 'description': return '#2563eb';
      case 'table_chart': return '#059669';
      case 'slideshow': return '#db2777';
      default: return '#6b7280';
    }
  }

  onClick(att: AttachmentRef): void {
    if (this.loadingId) return;
    this.loadingId = att.id;
    this.openAttachment.emit(att);
  }

  markDone(id: string): void {
    if (this.loadingId === id) this.loadingId = null;
  }
}
